import { render, staticRenderFns } from "./LabExamForm.vue?vue&type=template&id=3e272171&scoped=true"
import script from "./LabExamForm.vue?vue&type=script&lang=js"
export * from "./LabExamForm.vue?vue&type=script&lang=js"
import style0 from "./LabExamForm.vue?vue&type=style&index=0&id=3e272171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e272171",
  null
  
)

export default component.exports